import PropTypes from "prop-types"
import React from "react"

import Badge from "src/components/Badge"
import { statusToken } from "src/components/Badge/status_tokens"

import { snakecaseToTitlecase } from "src/utils/string_helpers"

const Status = ({ data }) => {
  const label = data ? snakecaseToTitlecase(data) : null
  return (
    <div className="flex items-center justify-end lg:w-auto lg:flex-none">
      {label && (
        <Badge color={statusToken(label)} text={label} variant="small" />
      )}
    </div>
  )
}

Status.propTypes = {
  data: PropTypes.string,
}

export default Status
